'use client';

import { UpOutlined } from '@ant-design/icons';
import { useCallback } from 'react';

import './scroll-to-top.scss';

const ScrollToTop = ({ id }) => {
  const handleClick = useCallback(() => {
    const blockToScroll = document.getElementById(id ?? 'header');

    blockToScroll?.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }, []);

  return (
    <button type="button" className="scroll-to-top" onClick={handleClick} aria-label="Scroll to top">
      <UpOutlined />
    </button>
  );
};

export default ScrollToTop;
